<template>
  <div class="news">
    <banner title="新闻资讯" />
    <div class="news-section" v-loading="loading">
      <div class="news-section-content">
        <div class="content-nav">
          <div
            class="content-nav-btn"
            :class="{ 'content-nav-active': newstype == 1 }"
            @click="newstype = 1"
          >
            <span>智慧养老</span>
          </div>
        </div>

        <div class="content-nav-item">
          <div class="item-list" v-for="(item, index) in newsList" :key="index">
            <div class="item-img">
              <img :src="item.Img" alt="" />
            </div>
            <p class="item-list-title">{{ item.Title }}</p>
            <p class="item-list-content">{{ item.Content }}</p>
            <div class="item-list-more">
              <router-link
                class="text-decoration"
                :to="{ name: 'newsdetails', params: { id: item.Id } }"
              >
                <img src="../assets/img/sanjiao.png" />
                <span>查看详情</span>
              </router-link>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import Banner from "../components/Banner";
export default {
  name: "news",
  components: {
    Banner,
  },
  data() {
    return {
      loading: false,
      newsList: [
        {
          Id: "1",
          Title: "智慧养老有哪些发展机会？两会代表给出建议...",
          Img: require("../assets/img/new_1.png"),
          CreateTime: "2024-04-16 17:51",
          Content:
            "智慧养老是指利用信息技术对养老赋能，帮助老年人过上有价值、有意义的幸福生活，包括可穿戴设备、康复辅助器具等产品，涉及生活照料、医疗护理、上门服务等多方面。智慧养老支撑中国的老人正在由生存型养老向品质型养老迈进。“传统养老模式已不能满足当前及未来的养老需求。”全国政协委员、武汉大学土木建筑工程学院教授徐礼华表示，在对社区硬件设施进行适老化系统改造的同时，应调整优化养老服务的智能化水平，构建城镇适老化社区智能化康养服务平台，让更多老年人实现居家康养生活。徐礼华委员建议，鼓励社会资本参与构建智能化康养服务平台，利用物联网等新一代信息技术产品，实现个人、家庭、社区、机构与健康养老资源的有效对接和优化配置。积极发挥院校培养人才的渠道作用，建立企业和从业人员的资质认证制度，助推智慧养老工作走上专业化、规范化、职业化的良性发展道路。",
        },
        {
          Id: "2",
          Title: "看懂智慧养老",
          Img: require("../assets/img/new_2.png"),
          CreateTime: "2024-04-22 18:05",
          Content:
            "2024年开年，首场国务院常务会议就聚焦老年人群，研究发展银发经济、增进老年人福祉的政策举措。1月15日，国务院办公厅印发《关于发展银发经济增进老年人福祉的意见》，提出4个方面26项举措。这是我国首个以“银发经济”命名的政策文件。未来，国家将着力培育高精尖产品和高品质服务模式，让老年人共享发展成果，安享幸福晚年。银发经济覆盖面广，但现阶段相关产业主要集中在餐饮、护理、保健等基础养老服务方面。而老年人多元化、差异化、个性化的需求，正变得越来越旺盛和迫切，却尚未得到有效满足，这其中蕴含着巨大的发展机遇。老龄产业将迎来更多创新与融合发展的机遇。作为智慧养老服务平台，我们期望的是“融合创新 智慧养老”。随着科技进步和跨界合作的深化，养老服务将更加智慧化、个性化，满足老年人多元化需求。我们致力于推动政策、资源、技术等多方力量融合，希望能打破传统边界，实现跨界融合，共同开创老龄产业的美好未来。通过科技助力、服务升级，让老年人享受更加幸福、健康的晚年生活。",
        },
        {
          Id: "3",
          Title: "告别实体店...全新智慧养老成为主流",
          Img: require("../assets/img/new_3.png"),
          CreateTime: " 2024-06-07 15:44s",
          Content:
            "在数字化浪潮的冲击下，许多实体店正面临着前所未有的挑战，亏损现象屡见不鲜。然而，正是这样的时代背景下，居家养老产业却展现出了巨大的发展潜力和广阔的市场前景。中国作为人口大国，老龄化问题尤为突出，如何为老年人提供高品质、个性化的养老服务，确保他们安享晚年，成为社会关注的焦点。传统的家庭养老和机构养老已不能满足日益增长的需求，而智慧居家养老的兴起，为解决老龄化问题提供了新的解决方案。 市场竞争加剧：随着互联网电商的快速发展，消费者购物渠道日益多样化，实体店面临着来自线上平台的激烈竞争。成本压力大：实体店需要承担高昂的租金、人力成本等费用，而在利润空间有限的情况下，这些成本压力无疑加剧了亏损的风险。消费者行为转变：随着年轻消费群体的崛起，他们的消费习 惯和购物需求发生了显著变化，更注重个性化、便捷化和体验化。这使得传统实体店在吸引年轻消费者方面面临挑战。市场需求旺盛：随着社会老龄化的加速推进，居家养老成为越来越多老年人的首选。他们对居家养老服务的需求日益增长，为产业发展提供了广阔的市场空间。政策支持力度加大：为应对老龄化挑战，政府出台了一系列政策措施，鼓励和支持居家养老产业的发展。这些政策为居家养老服务机构提供了更多的发展机会和优惠政策。创新服务模式不断涌现：随着科技的进步，越来越多的创新服务模式应用于居家养老领域，如智能养老设备、远程医疗服务等。这些创新服务模式不仅提升了服务质量，也满足了老年人的多样化需求。  ",
        },
      ],
      newstype: 1,
    };
  },
  watch: {
    newstype(type) {
      window.console.log(type);
      this.loadData();
    },
  },
  mounted() {
    this.loadData();
  },
  methods: {
    loadData() {
      this.loading = false;
    },
  },
};
</script>

<style lang="scss" scoped>
* {
  margin: 0;
  padding: 0;
}
img {
  width: 100%;
  height: 100%;
}
.news {
  width: 100%;
  height: 100%;
  background-color: rgb(255, 118, 64, 0.9);
  position: relative;
  overflow: hidden;

  &-section {
    width: 100%;
    //height: 1600px;

    &-content {
      width: 1240px;
      //height: 1600px;
      margin: 0 auto;
      background-color: #fff;
      border: 1px solid red;

      .content-nav {
        width: 400px;
        height: 55px;
        margin: 0 auto;
        display: flex;
        //justify-content: center;
        align-items: center;
        position: relative;
        bottom: 30px;
        border: 1px solid red;

        &-btn {
          width: 100%;
          height: 100%;
          display: flex;
          align-items: center;
          justify-content: center;
          background-color: #e4e4e4;
          transition: all 0.2s;
        }

        .content-nav-active {
          background-color: red;
          color: #fff;
        }
      }

      .content-nav-item {
        width: 1070px;
        margin: 0 auto;
        display: flex;
        justify-content: flex-start;
        flex-wrap: wrap;
        //border: 1px solid blue;

        .item-list {
          width: 330px;
          height: 500px;
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
          margin: 10px 10px;
          border: 1px solid #15669e;

          &:hover {
            border: 1px solid #fff;
            box-shadow: 0 0 5px 2px #bfd3e0;
          }
          .item-img {
            width: 300px;
            height: 210px;
          }
          &-title {
            width: 300px;
            height: 60px;
            color: #15669e;
            font-size: 22px;
            padding: 0 10px;
            margin: 20px 0;
            overflow: hidden;
            text-overflow: ellipsis;
            border-left: 1px solid #15669e;
          }

          &-content {
            width: 273px;
            height: 100px;
            font-size: 14px;
            color: gray;

            // 文本长度处理 begin
            overflow: hidden;
            text-overflow: ellipsis;
            display: -webkit-box;
            -webkit-line-clamp: 5;
            -webkit-box-orient: vertical;
            white-space: normal !important;
            word-wrap: break-word;
            // 文本长度处理 ending
          }

          &-more {
            width: 273px;
            padding-top: 20px;
            display: flex;
            justify-content: flex-start;
            align-items: center;

            img {
              width: 12px;
              height: 12px;
            }
            span {
              color: #e13834;
              padding: 0 5px;
            }
          }
        }
      }
    }
  }
  .text-decoration {
    text-decoration: none;
  }
}
</style>